import { useEffect, useState } from "react";
import { webApi } from "@/lib/api";

let cache = null;
export function useWebConfig() {
  const [cfg, setCfg] = useState(cache || { phone: "", whatsapp: "", email: "", address: "", hours: "", play_store: "", app_store: "" });
  useEffect(() => { if (!cache) webApi.get("/web/config").then((c) => { cache = c; setCfg(c); }).catch(() => {}); }, []);
  return cfg;
}
